import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql, Link } from "gatsby"
import styled from "@emotion/styled"
import { color, breakpoints } from "../../../utils/style"
import OpenSubsLink from "./OpenSubsLink"
import GetWindowWidth from "../../shared/GetWindowWidth"

const Wrapper = styled("div")`
  position: relative;
  margin: 40px 0 0;
  @media (max-width: ${breakpoints.md}) {
    .subcats-menu {
      float: none;
    }
  }
`

const SubsUl = styled("ul")`
  @media(max-width: ${breakpoints.sm}) {
    clear: both;
    border: 4px solid ${color.red};
    background: rgba(26, 1, 1, 0.95);
    box-shadow: 0 0 48px rgba(142, 0, 0, 0.6);
    border-radius: 0 0 8px 8px;
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    z-index: 2;
    padding: 20px;
    height: 0;
    transition: height 0.5s ease;
    opacity: 0;
    li {
      display: none;
    }
    &.open {
      height: auto;
      opacity: 1;
      li {
        display: block;
      }
      a {
        border: none;
        text-align: left;
      }
    } 
  }
`

const SubLi = styled("li")`
  display: inline-block;
  vertical-align: top;
  margin: 0.66%;
  a {
    border: 2px solid #FFFFFF;
    border-radius: 4px;
    text-transform: uppercase;
    text-decoration: none;
    padding: 7px 16px;
    transition: 0.15s all;
    &:hover {
      color: ${color.gold};
      border-color: ${color.gold};  
    }
  }
  .active {
    color: ${color.gold};
    border-color: ${color.gold};
  }
  @media (max-width: ${breakpoints.md}) {
    margin: 1%;
    a {
      
    }
  }
`

const handleButtonClick = () => {
  const subcatsList = document.getElementById("subcats-ul")
  const submenuBtn = document.getElementById("submenu-button")
  if (subcatsList) {
    subcatsList.classList.toggle("open")
  }
  if(submenuBtn) {
    submenuBtn.classList.toggle("active")
  }
}

const Subcategories = props => (
  <StaticQuery
    query={graphql`
      {
        allWordpressCategory(
          filter: { parent_element: { wordpress_id: { eq: 51 } } }
        ) {
          edges {
            node {
              path
              name
              wordpress_id
            }
          }
        }
      }
    `}
    render={data => {
      const windowWidth = GetWindowWidth()
      const isDesktop = windowWidth > 600

      return (
        <Wrapper>
          {isDesktop && (
            <SubsUl id="subcats-ul">
              <SubLi key={"title-filter-key"}>
                <span>Select category:</span>
              </SubLi>
              <SubLi key={"main-page-key"}>
                <Link to={`/blog/`} activeClassName="active">
                  <span>ทั้งหมด</span>
                </Link>
              </SubLi>
              {data.allWordpressCategory.edges.map((item, index) => {
                return (
                  <SubLi key={index + Math.random() *100}>
                    <Link
                      to={item.node.path.replace(/^\/category\//g, "/")}
                      activeClassName="active"
                    >
                      <span
                        dangerouslySetInnerHTML={{ __html: item.node.name }}
                      />
                    </Link>
                  </SubLi>
                )
              })}
            </SubsUl>
          )}
          {!isDesktop && (
            <>
              <OpenSubsLink
                title={props.title}
                key={"filter-button-key-mobile"}
                handlerFunction={() => handleButtonClick()}
              />
              <SubsUl id="subcats-ul">
                <SubLi key={"main-page-mobile-key"}>
                  <Link to={`/blog/`} activeClassName="active">
                    <span>ทั้งหมด</span>
                  </Link>
                </SubLi>
                {data.allWordpressCategory.edges.map((item, index) => (
                  <SubLi key={index + Math.random() *100}>
                    <Link
                      to={item.node.path.replace("category/", "")}
                      activeClassName="active"
                    >
                      {item.node.name}
                    </Link>
                  </SubLi>
                ))}
              </SubsUl>
            </>
          )}
        </Wrapper>
      )
    }}
  />
)

export default Subcategories;

Subcategories.propTypes = {
  title: PropTypes.string.isRequired,
};
